module.exports = __webpack_public_path__ + "media/images/GreyWhiteBanner2-a9707090501f2e27786a008a2fa07507.png";